//@ts-ignore
import {start} from '@salesforce/pwa-kit-react-sdk/ssr/browser/main'

start()
